var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"card cursor",on:{"click":_vm.play}},[_c('div',{staticClass:"img",style:({backgroundImage: 'url(' + _vm.resource.图片地址 + ')'})}),_c('div',{staticClass:"lesson-detail"},[_c('h4',[_vm._v(_vm._s(_vm.resource.课件标题))])]),_c('div',{staticClass:"lesson-desc"},[_c('span',[_vm._v(_vm._s(_vm.resource.章节名称))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }